/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_METADATA = 'REQUESTED_METADATA';
export const requestedMetadata = () => ({
  type: REQUESTED_METADATA
});

export const RECEIVED_METADATA = 'RECEIVED_METADATA';
export const receivedMetadata = (metadata) => ({
  type: RECEIVED_METADATA,
  metadata
});

export const ERROR_METADATA = 'ERROR_METADATA';
export const errorMetadata = (error) => ({
  type: ERROR_METADATA,
  error
});
